/*
 * NICOCHILL カート追加のネットワーク層ガード
 *   (1) 個人輸入 120mL 上限のハードブロック
 *   (2) 発売前（商品タグ coming-soon）のハードブロック
 * ---------------------------------------------------------------------------
 * 目的:
 *   「上限を超えると警告は出るが購入はできてしまう」状態をやめ、
 *   上限（既定 120mL = POD/デバイス 6個）を超えるカート操作そのものを成立させない。
 *
 * なぜ fetch をラップするのか:
 *   カートに物が入る経路は非常に多い（Dawn の product-form.js / quick-add.js /
 *   quick-add-bulk.js / quick-order-list.js / cart.js の数量変更 / cart-drawer.js、
 *   さらに RICHILL LP や nicochill-polish.js の独自 fetch）。これらは全て
 *   最終的に /cart/add.js・/cart/change.js・/cart/update.js を fetch で叩く。
 *   フォームごとにバリデータを足すと必ず取りこぼすので、共通の出口である
 *   fetch を1か所でラップして「上限を超える要求は送らない」ようにする。
 *   このリポジトリに無いライブ専用ファイル（cart.js 等）もまとめて塞げる。
 *
 * ブロックの返し方:
 *   ネットワークに出さずに、各呼び出し元が「Shopify が拒否した」と解釈できる
 *   レスポンスを合成して返す。
 *     - /cart/add.js    → 422 + { status, message, description }
 *                         （Dawn product-form.js が description を
 *                           .product-form__error-message にそのまま出す）
 *     - /cart/change.js → { errors: "..." }
 *                         （Dawn cart.js が数量を元に戻して行エラーを出す）
 *     - /cart/update.js → { errors: "..." }
 *   加えて、エラー表示DOMを持たない呼び出し元（card-product の quick add 等）でも
 *   理由が必ず伝わるように、自前のトーストも出す。
 *
 * 失敗時の方針:
 *   設定JSONが無い・/cart.js が取れない・想定外の本文などは「素通し」にする。
 *   ここで詰まらせると購入導線が丸ごと死ぬため。カートページ側は
 *   sections/main-cart-footer.liquid が Liquid（サーバー側）で購入ボタンを
 *   無効化するので、素通ししても最終的な購入は止まる。
 */
(function () {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;
  if (window.__ncMlGuardInstalled) return;
  window.__ncMlGuardInstalled = true;

  /* ---------- 設定 ---------- */

  // nicochill-polish.js の unitsForLine と同じ契約
  // （line-bot/lib/set-breakdown.js のセット内訳キーと共通）
  var RE_POD = /^POD\s*\d+$/;
  var RE_DEV = /^デバイス(\d+|本体)$/;

  var cfg = { mlPerUnit: 20, mlLimit: 120, unitLimit: 6, unitMap: {}, enabled: true, soonIds: {} };

  // 設定の出どころは2つ。
  //   #nc-ml-config   … snippets/nc-ml-config.liquid が全ページの <head> に出す（既定値）
  //   #nc-cart-addons … sections/main-cart-footer.liquid がカートページに出す（section 設定が実効値）
  // カートページでは後者を優先して、上限の変更が管理画面のセクション設定1か所で効くようにする。
  (function readConfig() {
    var applied = false;
    ['nc-ml-config', 'nc-cart-addons'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var raw;
      try { raw = JSON.parse(el.textContent); } catch (e) { return; }
      if (!raw) return;
      // 発売前IDは 120mL の設定と独立に読む。
      // mlLimit が無い・壊れている設定でも発売前ガードだけは効かせたい。
      if (Array.isArray(raw.soonIds)) {
        for (var si = 0; si < raw.soonIds.length; si++) {
          var sid = String(raw.soonIds[si]);
          if (sid) cfg.soonIds[sid] = true;
        }
      }
      if (!(Number(raw.mlLimit) > 0)) return;
      // enabled は #nc-cart-addons ではピッカーの表示可否なので、ガードの可否には使わない
      if (id === 'nc-ml-config' && raw.enabled === false) cfg.enabled = false;
      cfg.mlPerUnit = Math.max(1, Number(raw.mlPerUnit) || 20);
      cfg.mlLimit = Math.max(0, Number(raw.mlLimit) || 0);
      cfg.unitMap = raw.unitMap || {};
      applied = true;
    });
    if (!applied) { cfg.enabled = false; return; }
    cfg.unitLimit = cfg.mlLimit > 0 ? Math.floor(cfg.mlLimit / cfg.mlPerUnit) : 0;
  })();

  // 上限が引けない設定なら mL 判定はしない（0 を上限として全部ブロックしないため）。
  // 発売前ガードは 120mL とは独立に動く。
  var mlActive = cfg.enabled && cfg.unitLimit >= 1;
  var soonActive = Object.keys(cfg.soonIds).length > 0;
  if (!mlActive && !soonActive) return;

  var origFetch = window.fetch.bind(window);

  /* ---------- URL 判定 ---------- */

  function urlOf(input) {
    try {
      if (typeof input === 'string') return input;
      if (typeof URL !== 'undefined' && input instanceof URL) return input.href;
      if (input && typeof input.url === 'string') return input.url;
    } catch (e) {}
    return '';
  }

  // ロケール接頭辞（/ja/cart/add.js 等）が付くことがあるので末尾一致で見る
  function cartOp(input) {
    var raw = urlOf(input);
    if (!raw) return null;
    var pathname;
    try { pathname = new URL(raw, window.location.origin).pathname; }
    catch (e) { pathname = String(raw).split('?')[0]; }
    var m = /\/cart\/(add|change|update)(\.js)?$/.exec(pathname);
    return m ? m[1] : null;
  }

  /* ---------- 本文の読み取り ---------- */

  // Dawn は fetch(url, config) 形式なので init.body に入る。
  // Request オブジェクトで渡された場合だけ clone して読む。
  function readBody(input, init) {
    var body = init && init.body;
    if (body == null && input && typeof input.clone === 'function') {
      try { return input.clone().text().then(function (t) { return { text: t }; }); }
      catch (e) { return Promise.resolve(null); }
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) return Promise.resolve({ form: body });
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return Promise.resolve({ form: body });
    if (typeof body === 'string') return Promise.resolve({ text: body });
    return Promise.resolve(null);
  }

  function parseJson(text) {
    if (typeof text !== 'string') return null;
    try { return JSON.parse(text); } catch (e) { return null; }
  }

  /* ---------- 単位数の計算（nicochill-polish.js と同じ規則） ---------- */

  function unitsFor(variantId, properties) {
    var n = 0;
    var props = properties || {};
    var keys = Object.keys(props);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (k.charAt(0) === '_') continue;             // _line_link 等の隠しプロパティ
      var v = props[k];
      if (v == null || String(v).trim() === '') continue;
      if (RE_POD.test(k) || RE_DEV.test(k)) n++;
    }
    var declared = Number(cfg.unitMap[String(variantId)] || 0);
    // 2つのシグナルは逆方向に失敗する（property は過小、unitMap は陳腐化）ので大きい方を採る
    return Math.max(n, declared);
  }

  // 追加要求（/cart/add.js）の中身を { id, quantity, units } の配列にする
  function itemsFromForm(fd) {
    var props = {};
    fd.forEach(function (value, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m) props[m[1]] = value;
    });
    var id = fd.get('id');
    if (id == null || String(id) === '') return [];
    var qty = Number(fd.get('quantity'));
    if (!(qty > 0)) qty = 1;
    return [{ id: String(id), quantity: qty, units: unitsFor(id, props) }];
  }

  function itemsFromJson(obj) {
    if (!obj) return [];
    var list = Array.isArray(obj.items) ? obj.items : (obj.id != null ? [obj] : []);
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var it = list[i] || {};
      if (it.id == null) continue;
      var qty = Number(it.quantity == null ? 1 : it.quantity);
      if (!(qty > 0)) continue;
      out.push({ id: String(it.id), quantity: qty, units: unitsFor(it.id, it.properties) });
    }
    return out;
  }

  /* ---------- 現在のカート ---------- */

  var cartPromise = null;

  function loadCart() {
    if (cartPromise) return cartPromise;
    var url = (window.routes && window.routes.cart_url) || '/cart';
    var p = origFetch(url + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = ((cart && cart.items) || []).map(function (it) {
          return {
            key: String(it.key || ''),
            variantId: String(it.variant_id),
            quantity: Number(it.quantity) || 0,
            per: unitsFor(it.variant_id, it.properties)
          };
        });
        return lines;
      });
    cartPromise = p;
    p.catch(function () { if (cartPromise === p) cartPromise = null; });
    return p;
  }

  function invalidateCart() { cartPromise = null; }

  function sumLines(lines) {
    var n = 0;
    for (var i = 0; i < lines.length; i++) n += lines[i].per * lines[i].quantity;
    return n;
  }

  /* ---------- 文言 ---------- */

  var ML = function (units) { return units * cfg.mlPerUnit; };

  function message(currentUnits, addUnits) {
    var left = Math.max(0, cfg.unitLimit - currentUnits);
    var head = '個人輸入でお持ち込みいただける上限は1ヶ月あたり ' + cfg.mlLimit + 'mL までです'
      + '（POD・デバイス1個＝' + cfg.mlPerUnit + 'mL）。';
    if (addUnits > 0) {
      head += 'カートには現在 ' + ML(currentUnits) + 'mL 分が入っており、'
        + 'さらに ' + ML(addUnits) + 'mL 分を追加すると上限を超えます。';
    } else {
      head += '変更後の数量は ' + ML(currentUnits) + 'mL 分となり上限を超えます。';
    }
    head += left > 0
      ? 'あと ' + left + '個（' + ML(left) + 'mL）まで追加できます。'
      : 'これ以上は追加できません。';
    return head;
  }

  function overMessage(nextUnits) {
    return '個人輸入でお持ち込みいただける上限は1ヶ月あたり ' + cfg.mlLimit + 'mL までです'
      + '（POD・デバイス1個＝' + cfg.mlPerUnit + 'mL）。'
      + 'この数量では ' + ML(nextUnits) + 'mL となり上限を超えるため変更できません。';
  }

  /* ---------- 合成レスポンス ---------- */

  function blockedResponse(op, msg, title) {
    var head = title || '数量をご確認ください';
    var payload = op === 'add'
      ? { status: 422, message: head, description: msg }
      : { errors: msg, status: 422, message: head, description: msg };
    return new Response(JSON.stringify(payload), {
      status: 422,
      statusText: 'Unprocessable Entity',
      headers: { 'Content-Type': 'application/json' }
    });
  }

  /* ---------- トースト（エラー表示DOMを持たない呼び出し元向け） ---------- */

  var toastEl = null;
  var toastTimer = null;

  function ensureToastStyles() {
    if (document.getElementById('nc-ml-guard-style')) return;
    var s = document.createElement('style');
    s.id = 'nc-ml-guard-style';
    s.textContent = [
      '.nc-mlg-toast{position:fixed;left:50%;bottom:2.4rem;transform:translateX(-50%) translateY(1rem);',
      'z-index:2147483000;max-width:min(46rem,calc(100vw - 3.2rem));box-sizing:border-box;',
      'background:#1a1a1a;color:#fff;padding:1.4rem 1.8rem;border-radius:0.8rem;',
      'font-size:1.3rem;line-height:1.7;letter-spacing:0.01em;box-shadow:0 1.2rem 3.2rem rgba(0,0,0,.28);',
      'opacity:0;pointer-events:none;transition:opacity .18s ease,transform .18s ease}',
      '.nc-mlg-toast.is-open{opacity:1;transform:translateX(-50%) translateY(0)}',
      '@media (prefers-reduced-motion:reduce){.nc-mlg-toast{transition:none}}'
    ].join('');
    document.head.appendChild(s);
  }

  function toast(msg) {
    try {
      if (!document.body) return;
      ensureToastStyles();
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'nc-mlg-toast';
        toastEl.setAttribute('role', 'alert');
        toastEl.setAttribute('aria-live', 'assertive');
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = msg;
      // 直前の状態から必ず遷移させる
      toastEl.classList.remove('is-open');
      void toastEl.offsetWidth;
      toastEl.classList.add('is-open');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { if (toastEl) toastEl.classList.remove('is-open'); }, 7000);
    } catch (e) {}
  }

  // reason は 'ml'（120mL上限超過）か 'soon'（発売前）。文言で判別すると
  // コピーを直すたびに壊れるので、判定側から理由そのものを持ち回る。
  // 受け手: assets/nc-clarity.js（Clarity のイベントに分けて送る）
  function reject(op, msg, title, reason) {
    toast(msg);
    try {
      document.dispatchEvent(new CustomEvent('nc:ml-limit-blocked', {
        detail: { message: msg, op: op, reason: reason || 'ml' },
      }));
    } catch (e) {}
    return blockedResponse(op, msg, title);
  }

  /* ---------- 判定 ---------- */

  // 発売前（tag: coming-soon）。snippets/nc-ml-config.liquid の soonIds が出どころ。
  // カートの取得可否に依存しないので、120mL 判定より先に、loadCart の外で判定する。
  var SOON_TITLE = '現在ご購入いただけません';
  var SOON_MSG = 'この商品は発売前のため、現在ご購入いただけません。発売が決まり次第、ストア・メール・LINEでお知らせします。';

  function hasSoonItem(payload) {
    if (!soonActive) return false;
    var items;
    try {
      items = payload.form ? itemsFromForm(payload.form) : itemsFromJson(parseJson(payload.text));
    } catch (e) { return false; }
    for (var i = 0; i < items.length; i++) {
      if (cfg.soonIds[String(items[i].id)]) return true;
    }
    return false;
  }

  // 戻り値: null なら通す / 文字列ならその文言でブロック
  function judgeAdd(lines, payload) {
    var items = payload.form ? itemsFromForm(payload.form) : itemsFromJson(parseJson(payload.text));
    if (!items.length) return null;
    var addUnits = 0;
    for (var i = 0; i < items.length; i++) addUnits += items[i].units * items[i].quantity;
    if (addUnits <= 0) return null;                       // ポスター等、枠を消費しない商品
    var current = sumLines(lines);
    if (current + addUnits <= cfg.unitLimit) return null;
    return message(current, addUnits);
  }

  function judgeChange(lines, payload) {
    var body = parseJson(payload.text);
    if (!body) return null;
    var qty = Number(body.quantity);
    if (!isFinite(qty)) return null;

    var idx = -1;
    if (body.line != null) {
      idx = Number(body.line) - 1;
    } else if (body.id != null) {
      var id = String(body.id);
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].key === id) { idx = i; break; }
      }
      if (idx < 0) {
        for (var j = 0; j < lines.length; j++) {
          if (lines[j].variantId === id) { idx = j; break; }
        }
      }
    }
    if (idx < 0 || idx >= lines.length) return null;
    if (qty <= lines[idx].quantity) return null;          // 減らす・据え置きは常に許可

    var next = sumLines(lines) - lines[idx].per * lines[idx].quantity + lines[idx].per * qty;
    if (next <= cfg.unitLimit) return null;
    return overMessage(next);
  }

  function judgeUpdate(lines, payload) {
    var body = parseJson(payload.text);
    if (!body || !body.updates) return null;              // note / attributes だけの更新は対象外
    var updates = body.updates;

    var next = 0;
    var increased = false;
    var consumed = {};

    if (Array.isArray(updates)) {
      for (var i = 0; i < lines.length; i++) {
        var q = i < updates.length ? Number(updates[i]) : lines[i].quantity;
        if (!isFinite(q) || q < 0) q = lines[i].quantity;
        if (q > lines[i].quantity) increased = true;
        next += lines[i].per * q;
      }
    } else {
      for (var k = 0; k < lines.length; k++) {
        var line = lines[k];
        var raw = null;
        if (Object.prototype.hasOwnProperty.call(updates, line.key) && !consumed[line.key]) {
          raw = updates[line.key];
          consumed[line.key] = true;
        } else if (Object.prototype.hasOwnProperty.call(updates, line.variantId) && !consumed[line.variantId]) {
          raw = updates[line.variantId];
          consumed[line.variantId] = true;
        }
        var qn = raw == null ? line.quantity : Number(raw);
        if (!isFinite(qn) || qn < 0) qn = line.quantity;
        if (qn > line.quantity) increased = true;
        next += line.per * qn;
      }
      // カートに無いバリアントを updates で足す使い方（quick add bulk 等）
      var keys = Object.keys(updates);
      for (var m = 0; m < keys.length; m++) {
        var key = keys[m];
        if (consumed[key]) continue;
        var addQty = Number(updates[key]);
        if (!(addQty > 0)) continue;
        var per = unitsFor(key, null);
        if (per <= 0) continue;
        increased = true;
        next += per * addQty;
      }
    }

    if (!increased) return null;
    if (next <= cfg.unitLimit) return null;
    return overMessage(next);
  }

  /* ---------- カートページの購入ボタン同期 ---------- */

  // .cart__ctas は Section Rendering の差し替え対象（.js-contents）の外にあるため、
  // 数量を減らして上限内に戻っても Liquid が出した disabled が残り続ける。
  // カートを更新したあとに自前で付け外しする。
  // Liquid 側の数え方（正規表現が使えず contains で近似）はJS側より広く拾うことがあるので、
  // 「Liquid が出した disabled を初回描画時にJSが外す」ことは許さない。
  // カートを実際に更新したあとだけ、上限内に戻ったとみなして解除する。
  var cartMutated = false;

  function syncCartPage() {
    if (!mlActive) return;
    var btn = document.getElementById('checkout');
    var block = document.getElementById('nc-ml-block');
    var dyn = document.getElementById('nc-dynamic-checkout');
    if (!btn && !block && !dyn) return;

    loadCart().then(function (lines) {
      var units = sumLines(lines);
      var over = units > cfg.unitLimit;
      var empty = lines.length === 0;

      var mayRelease = cartMutated;

      if (block) {
        if (over) {
          var cur = block.querySelector('[data-nc-ml-current]');
          var un = block.querySelector('[data-nc-ml-units]');
          if (cur) cur.textContent = ML(units) + 'mL';
          if (un) un.textContent = String(units);
          block.hidden = false;
        } else if (mayRelease) {
          block.hidden = true;
        }
      }
      if (btn) {
        // 空カートの disabled は Liquid の担当なので奪わない
        if (over || empty) btn.setAttribute('disabled', 'disabled');
        else if (mayRelease) btn.removeAttribute('disabled');
      }
      if (dyn) {
        if (over) dyn.hidden = true;
        else if (mayRelease) dyn.hidden = false;
      }
    }).catch(function () {});
  }

  /* ---------- fetch ラッパ ---------- */

  window.fetch = function (input, init) {
    var op;
    try { op = cartOp(input); } catch (e) { op = null; }
    if (!op) return origFetch(input, init);

    var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (method !== 'POST') return origFetch(input, init);

    // 行（数量）に触る要求かどうか。note / attributes だけの更新で
    // 「上限内に戻った」と誤認して disabled を外さないための区別。
    var touchesLines = op !== 'update';

    return readBody(input, init).then(function (payload) {
      if (!payload) return null;
      // 発売前は最優先。カートが取れなくても素通りさせない。
      if (op === 'add' && hasSoonItem(payload)) return { msg: SOON_MSG, title: SOON_TITLE, reason: 'soon' };
      if (op === 'update') {
        var parsed = payload.form ? null : parseJson(payload.text);
        touchesLines = !!(parsed && parsed.updates);
      }
      if (!mlActive) return null;
      return loadCart().then(function (lines) {
        var m;
        if (op === 'add') m = judgeAdd(lines, payload);
        else if (op === 'change') m = judgeChange(lines, payload);
        else m = judgeUpdate(lines, payload);
        return m ? { msg: m, reason: 'ml' } : null;
      });
    }).catch(function () {
      // 判定できなければ通す（購入導線を殺さない。最終防波堤はカートページの Liquid 側）
      return null;
    }).then(function (blocked) {
      if (blocked) return reject(op, blocked.msg, blocked.title, blocked.reason);
      return origFetch(input, init).then(function (res) {
        invalidateCart();
        if (res && res.ok && touchesLines) cartMutated = true;
        // 差し替え後のDOMに追いつけるよう次のタスクで同期する
        setTimeout(syncCartPage, 0);
        return res;
      }, function (err) {
        invalidateCart();
        throw err;
      });
    });
  };

  // 他のスクリプトが独自に更新した場合にもキャッシュを捨てる
  document.addEventListener('nc:cart-changed', function () { invalidateCart(); syncCartPage(); });
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) { invalidateCart(); syncCartPage(); }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartPage);
  } else {
    syncCartPage();
  }
})();
